import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
require('./styles/main.css');
require('./components/Maintenance/styles.css');
require("babel-core/register");
require("babel-polyfill");

ReactDOM.render(
  <App />,
  document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js